import { CarouselDots } from 'components/carousel'
import { useRef } from 'react'
import Slider from 'react-slick'
import { useTheme } from '@mui/material/styles'
import Image from 'components/Image'
import { styled } from '@mui/material/styles'

type ImageProps = {
  mobileviewheight?: string
}

const StyledImage = styled(Image)<ImageProps>(
  ({ theme, mobileviewheight }) => ({
    [theme.breakpoints.down('md')]: {
      height: mobileviewheight ? mobileviewheight : 'unset',
    },
  }),
)

interface ICarousel {
  data: { image: string; link: string; alt: string }[]
  sx?: any
  mobileviewheight?: string
}

const Carousel = ({ data = [], sx, mobileviewheight }: ICarousel) => {
  const theme = useTheme()
  const settings = {
    speed: 800,
    dots: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rtl: Boolean(theme.direction === 'rtl'),
    ...CarouselDots({
      left: 0,
      position: 'absolute',
      marginTop: '8px',
    }),
  }

  const carouselRef = useRef<Slider>(null)

  const redirectURL = (url: string) => {
    window.open(url, '_blank')
  }

  return (
    <Slider ref={carouselRef} {...settings}>
      {data.map((item, index) => (
        <StyledImage
          key={index}
          sx={{ ...sx }}
          src={item.image}
          onClick={() => redirectURL(item.link)}
          alt={item.alt}
          mobileviewheight={mobileviewheight}
        />
      ))}
    </Slider>
  )
}
export default Carousel
